/* This file is generated by Kubb. DO NOT EDIT MANUALLY. */

import type { GetUserPathParams } from './types/GetUser.ts';
import type { Client } from '@kubb/plugin-client/clients/fetch';
import { getUser } from './clients/getUser.ts';
import { getUsers } from './clients/getUsers.ts';

export class ApiClient {
  constructor(private readonly client: Client) {}

  getUsers() {
    return getUsers({ client: this.client });
  }
  getUser(id: GetUserPathParams['id']) {
    return getUser(id, { client: this.client });
  }
}
